import { FloatingMenu } from '@tiptap/react';
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";

import './style.css';

const SlashMenuHintComponent = ({ editor }) => {
  const tippyOptions = useMemo(() => ({ duration: 100 }), []);

  const shouldShowFn = useCallback(({ view, state }) => {
    const { selection } = state
    const { $anchor, empty } = selection

    if (
      !view.hasFocus() ||
      !empty ||
      !($anchor.parent.isTextblock &&
        !$anchor.parent.type.spec.code &&
        !$anchor.parent.textContent)
    ) {
      return false;
    }

    return true
  }, []);

  const handleTipClick = useCallback(() => {
    editor.chain().focus()
  }, [editor]);

  if (!editor) return null;

  return (
    <FloatingMenu
      className="floating-menu"
      editor={editor}
      shouldShow={shouldShowFn}
      tippyOptions={tippyOptions}
    >
      <div onClick={handleTipClick} className="slash-menu-container">
        <FormattedMessage id="TYPE_SLASH" defaultMessage="Type / for menu" />
      </div>
    </FloatingMenu>
  );
};

export default SlashMenuHintComponent;
